<div class="file-processing">
  <!-- Header -->
  <div class="file-processing__header">
    <span class="file-processing__title">Import files</span>
    <div class="file-processing__header-actions">
      <a class="file-processing__download-template"
        href="/assets/area_upload_template_guide.xlsx"
        download="area_upload_template_guide.xlsx"
        type="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        >
        <div class="icon icon-download"></div>
        Download Template
      </a>

      <div class="close icon icon-small-close" (click)="close()"></div>
    </div>
  </div>

  <div class="horizontal-separator"></div>

  <!-- File list -->
  @if (uploads.length) {
    <div class="file-processing__file-list">
      <div class="file-list">
        @for (file of uploads; track file) {
          <div class="file-item">
            <div class="file-info">
              <div class="icon row-file-icon"
                         [ngClass]="{
                          'icon-upload-file': getUploadStatus(file) === 'pending' || getUploadStatus(file) === 'progress',
                          'icon-import-success': getUploadStatus(file) === 'completed',
                          'icon-import-fail': getUploadStatus(file) === 'failed',
                          'icon-import-warning icon-import': getUploadStatus(file) === 'pending_confirmation'
                         }"
              ></div>
              <div class="file-name-wrapper">
                <span class="file-name" [matTooltip]="file.filename" [matTooltipPosition]="'right'">
                  {{
                  file.filename | truncate:32:{
                  preserveExtension: true,
                  spaceBeforeExt: true
                }
                }}
              </span>
              <span class="file-folder" [matTooltip]="getFileFolderPath(file)" [matTooltipPosition]="'right'">
                @for (part of getFolderPathParts(getFileFolderPath(file)); track part; let last = $last) {
                  @if (part === 'icon') {
                    <span class="icon icon-arrow-middle"></span>
                  } @else {
                    <span (click)="onFolderClick(file, last)" class="go-to-folder">
                      {{ part }}
                    </span>
                  }
                }
              </span>
            </div>
          </div>
          <div class="file-actions">
            <div class="file-status">
              @switch (getUploadStatus(file)) {
                @case ('completed') {
                  <span class="status-completed">Completed</span>
                }
                @case ('failed') {
                  <div class="status-error">
                    <inline-svg src="info.svg" color="#EB5752" class="info-icon" [matTooltip]="'Present in this files, but not in other'"></inline-svg>
                    Error
                    <button class="button view-button" type="button" (click)="showErrorDialog(file); $event.stopPropagation()">View Errors</button>
                  </div>
                }
                @case ('pending') {
                  <span class="status-pending">
                    Uploading...
                  </span>
                }
                @case ('progress') {
                  <span class="status-progress">
                    Uploading... ({{ getUploadPercentage(file) }}%)
                  </span>
                }
                @case ('pending_confirmation') {
                  <div class="status-warning"
                    (click)="showMismatchDialog(file); $event.stopPropagation()">
                    <inline-svg src="Warning.svg" color="#E7A918" class="info-icon" ></inline-svg>
                    Column mismatch detected
                    <button class="button view-button" type="button">View</button>
                  </div>
                }
                @default {
                  <span class="status-default">{{ file?.status }}</span>
                }
              }
            </div>
            @if (getUploadStatus(file) === 'failed' || getUploadStatus(file) === 'pending_confirmation') {
              <span class="icon icon-remove"
              (click)="removeFileUpload(file)"></span>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
</div>


<div class="file-processing__footer">
  <div class="file-processing__actions">
    <button mat-raised-button color="primary" type="button" class="frmg-primary-button" (click)="onImportMoreFilesClick($event)">Import More Files</button>
  </div>
</div>

